<div class="flex flex-col items-center justify-center h-full login-bg px-4 w-full">
    <h2 *ngIf="!this.token"
        class="text-5xl font-bold text-center mb-10">{{ "section.auth.sign-in.title" | translate }}</h2>

    <div *ngIf="!this.token"
         class="bg-white rounded-2xl p-10 w-full max-w-sm min-h-[600px] flex flex-col justify-between">
        <div class="flex flex-col justify-center mb-6 w-full">
            <div class="flex flex-col justify-center items-center">
                <div class="flex items-center justify-center w-12 h-12 border border-gray-200 rounded-full">
                    <i class="fal fa-key text-2xl text-gray-700"></i>
                </div>
            </div>
            <h2 class="text-3xl font-bold text-center my-3">{{ "section.auth.sign-in.login_option" | translate }}</h2>
        </div>

        <form #signInNgForm="ngForm" [formGroup]="signInForm" class="mt-4 space-y-4 flex flex-col flex-grow">
            <mat-form-field appearance="fill" class="w-full custom-rounded" hideRequiredMarker>
                <mat-label>{{ "section.auth.sign-in.login-mail" | translate }}</mat-label>
                <svg class="mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M5.121 17.804C7.21942 16.6179 9.58958 15.9963 12 16C14.5 16 16.847 16.655 18.879 17.804M15 10C15 10.7956 14.6839 11.5587 14.1213 12.1213C13.5587 12.6839 12.7956 13 12 13C11.2044 13 10.4413 12.6839 9.87868 12.1213C9.31607 11.5587 9 10.7956 9 10C9 9.20435 9.31607 8.44129 9.87868 7.87868C10.4413 7.31607 11.2044 7 12 7C12.7956 7 13.5587 7.31607 14.1213 7.87868C14.6839 8.44129 15 9.20435 15 10ZM21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z"
                        stroke="#8B90A2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <input matInput type="email" id="email" formControlName="email" class="w-full">
                <mat-error *ngIf="signInForm.get('email').hasError('required')">
                    {{ "section.auth.sign-in.fill-mail" | translate }}
                </mat-error>
                <mat-error *ngIf="signInForm.get('email').hasError('email')">
                    {{ "section.auth.sign-in.fill-valid-mail" | translate }}
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill" class="w-full custom-rounded" hideRequiredMarker>
                <mat-label>{{ "section.auth.sign-in.password" | translate }}</mat-label>
                <svg class="mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M8 11V7C8 5.93913 8.42143 4.92172 9.17157 4.17157C9.92172 3.42143 10.9391 3 12 3C13.0609 3 14.0783 3.42143 14.8284 4.17157C15.5786 4.92172 16 5.93913 16 7M12 15V17M6 21H18C18.5304 21 19.0391 20.7893 19.4142 20.4142C19.7893 20.0391 20 19.5304 20 19V13C20 12.4696 19.7893 11.9609 19.4142 11.5858C19.0391 11.2107 18.5304 11 18 11H6C5.46957 11 4.96086 11.2107 4.58579 11.5858C4.21071 11.9609 4 12.4696 4 13V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21Z"
                        stroke="#8B90A2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <input #passwordField [formControlName]="'password'" id="password" matInput type="password"/>
                <button type="button"
                        class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 mr-1"
                        (click)="passwordField.type === 'password' ? (passwordField.type = 'text') : (passwordField.type = 'password')">
                    <i *ngIf="passwordField.type === 'password'" class="far fa-eye"></i>
                    <i *ngIf="passwordField.type === 'text'" class="far fa-eye-slash"></i>
                </button>
                <mat-error *ngIf="signInForm.get('password').hasError('required')">
                    {{ "section.auth.sign-in.fill-password" | translate }}
                </mat-error>
            </mat-form-field>

            <button (click)="signIn()" type="submit"
                    [disabled]="signInForm.disabled"
                    class="w-full bg-[#FFC000] text-black rounded-[28px] py-3 flex items-center justify-center text-lg sign-text">
                <span>{{ "auth.signup.login_me" | translate }}</span>
                <i *ngIf="!signInForm.disabled" class="fa fa-chevron-right icon-size-3 ml-2 mt-1"></i>
                <i *ngIf="signInForm.disabled" class="fa fa-spinner icon-size-3 ml-2 mt-1 fa-spin"></i>
            </button>
        </form>

        <div class="items-center justify-center text-center flex flex-row text-black -mb-3">
            <div>
                <span class="mr-2">{{ "auth.forgot_pass" | translate }}</span>
                <a class="text-black underline font-semibold"
                   href="/forgot-password">{{ "auth.sign-in.find_pass" | translate }}</a>
            </div>

        </div>
    </div>

    <div *ngIf="this.token" class="flex flex-col min-h-screen justify-between">

        <div class="flex flex-col text-center justify-center w-full flex-grow">
            <h2 class="text-5xl font-bold text-center mb-3">{{ "section.auth.sign-in.title" | translate }}</h2>
            <span
                class="text-2xl font-bold text-center mb-4">{{ "section.auth.sign-in.redirecting" | translate }}</span>
            <div>
                <i class="text-center fa fa-spinner icon-size-8 fa-spin text-[#FFC000]"></i>
            </div>
        </div>

        <div *ngIf="this.cantLogin" class="flex items-center justify-center text-center text-black pb-6">
            <div>
                <span class="mr-2">{{ "auth.somthng_wrong" | translate }}</span>
                <a class="text-black underline font-semibold"
                   href="/sign-in">{{ "auth.signup.login_me" | translate }}</a>
            </div>
        </div>

    </div>

</div>
